// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XTY3","col":"styles_col__Qtcbf","actions":"styles_actions__3HYdb","conflict":"styles_conflict__1qAaK"};